import { Button, EmptyStates, Flex, Text } from '@inflearn/ds-react';
import { useTranslation } from 'next-i18next';

import { COURSE_URL } from '../../../../constants/urls';

function EmptyVoucherState() {
  const { t } = useTranslation();

  return (
    <Flex h="369px" align="center" justify="center">
      <EmptyStates
        title={t('보유한 강의가 없어요')}
        image="NO_DATA"
        body={
          <Text size="sm" align="center">
            {t('나를 성장시켜줄 새로운 지식을 찾아보세요.')}
          </Text>
        }
        cta={
          <Button
            variant="default"
            color="infgreen"
            size="xs"
            radius="md"
            component="a"
            href={COURSE_URL.COURSES({ types: 'ONLINE' })}
          >
            {t('강의 리스트 보기')}
          </Button>
        }
      />
    </Flex>
  );
}

function NoArchivedState() {
  const { t } = useTranslation();

  return (
    <Flex h="369px" align="center" justify="center">
      <EmptyStates
        title={t('숨긴 강의가 없어요')}
        image="NO_DATA"
        body={
          <Text size="sm" align="center">
            {t('보유한 유료 강의 하단의 [더보기] 버튼을 누르면')}

            <br />
            {t('강의를 숨길 수 있어요.')}
          </Text>
        }
      />
    </Flex>
  );
}

function NoSearchResultState({ onReset }: { onReset: () => void }) {
  const { t } = useTranslation();

  return (
    <Flex h="369px" align="center" justify="center">
      <EmptyStates
        title={t('검색 결과가 없어요')}
        image="NO_RESULT"
        body={
          <Text size="sm" align="center">
            {t('필터를 재설정하거나 검색어를 다시 입력해 보세요.')}
          </Text>
        }
        cta={
          <Button onClick={onReset} variant="default" color="infgreen" size="xs" radius="md">
            {t('검색 초기화')}
          </Button>
        }
      />
    </Flex>
  );
}

function ErrorState() {
  const { t } = useTranslation();

  return (
    <Flex h="369px" align="center" justify="center">
      <EmptyStates
        title={t('문제가 발생했어요')}
        image="ERROR"
        body={
          <Text size="sm" align="center">
            {t('새로고침 후 문제가 지속되면 지원팀에 문의해 주세요.')}
          </Text>
        }
      />
    </Flex>
  );
}

export const MyCoursesEmptyStates = {
  EmptyVoucherState,
  NoArchivedState,
  NoSearchResultState,
  ErrorState,
};
